import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { ArrowLeft, Mail, Phone, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
     <SEO
  title="Impressum Arabischkurs | Arabicroots"
  description="Rechtliche Angaben und Kontaktdaten von Arabicroots – Arabisch lernen online mit Struktur und persönlicher Betreuung."
  keywords="Impressum Arabicroots, Arabischkurs Kontakt, Anbieter Arabisch lernen Deutschland"
  url="/impressum"
  noIndex={true}
/>

  
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center group">
              <img
                src="/LogoHeader4.png"
                alt="Arabicroots Logo"
                className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </Link>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-[#970000] transition-colors duration-200"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Intro */}
        <div className="mb-12">
          <div className="inline-flex items-center rounded-full bg-[#970000]/10 text-[#970000] px-4 py-2 text-sm font-semibold mb-6">
            <FileText className="h-4 w-4 mr-2" />
            Rechtliche Angaben
          </div>

          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
            Impressum
          </h1>

          <p className="text-lg text-gray-600 leading-relaxed">
            Angaben gemäß § 5 DDG
          </p>
        </div>

        <div className="space-y-8">
          {/* Anbieter */}
          <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Anbieter
            </h2>

            <div className="space-y-2 text-gray-700 text-base md:text-lg leading-relaxed">
              <p className="font-semibold text-gray-900">Arabicroots</p>
              <p>Abdelilah Zahraoui</p>
              <p>c/o IP-Management #4911</p>
              <p>Ludwig-Erhard-Str. 18</p>
              <p>20459 Hamburg</p>
              <p>Deutschland</p>

              <div className="pt-4 mt-4 border-t border-gray-200">
                <p>
                  <span className="font-semibold text-gray-900">
                    Wirtschaftsidentifikationsnummer:
                  </span>{' '}
                  DE444650130
                </p>
              </div>
            </div>
          </section>

          {/* Kontakt */}
          <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Kontakt
            </h2>

            <div className="grid md:grid-cols-2 gap-5">
              <div className="bg-gray-50 rounded-2xl border border-gray-100 p-5 flex items-start">
                <div className="bg-[#970000] p-3 rounded-xl mr-4 flex-shrink-0">
                  <Phone className="h-5 w-5 text-white" />
                </div>

                <div>
                  <p className="font-semibold text-gray-900 mb-1">Telefon</p>
                  <p className="text-gray-700">+49 178 8378689</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-2xl border border-gray-100 p-5 flex items-start">
                <div className="bg-[#970000] p-3 rounded-xl mr-4 flex-shrink-0">
                  <Mail className="h-5 w-5 text-white" />
                </div>

                <div>
                  <p className="font-semibold text-gray-900 mb-1">E-Mail</p>
                  <p className="text-gray-700">info@arabicroots.de</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ImpressumPage;
